import { IColumnSetting, IGetUserListPayload } from 'src/app/shared/models/user.model'
import { IOption, TableColumnDefs, TablePaginationProps } from './table.model'
import { useSelector } from 'react-redux'
import { getDeferredConfig } from 'src/app/store/masterSetup'

export const defaultOptions: Array<IOption> = [
  {
    label: 'All Columns',
    value: 'All',
  },
]

export const defaultSearch = {
  searchTerm: '',
  searchColumns: defaultOptions[0].value,
}

export const defaultPageIndex = 0
export const defaultPagination = 1
export const defaultPageSize = 50
export const defaultPageSizeOptions: TablePaginationProps['pageSizeOptions'] = [10, 25, 50, 100]
export const defaultDownloadUrl = 'test' // TODO: update this download url later
export const defaultMaxChar = 255
export const emptyArrayLength = 0
export const defaultColumnMaxWidth = 340
export const defaultActionColumnMaxWidth = 64
export const defaultColumnDefs: Partial<TableColumnDefs> = {
  wrapText: true,
  wrapHeaderText: true,
  autoHeight: true,
  autoHeaderHeight: true,
  suppressSizeToFit: true,
  sortable: true, // keep sort icon
  comparator: () => 0,
  suppressAutoSize: true,
  // maxWidth: defaultColumnMaxWidth,
}
export const defaultActionColId = 'actions'
export const defaultSearchData: Partial<IGetUserListPayload> = {
  pageIndex: defaultPagination,
  pageSize: defaultPageSize,
  // searchColumns: [],
  // searchTerm: '',
  // sortColumns: [],
  // isDesc: false,
}

export const useDefaultSearchData = (columnSettings?: IColumnSetting[]) => {
  const majorConfig = useSelector(getDeferredConfig)
  const data: { [prop: string]: any } = {
    pageIndex: defaultPagination,
    pageSize: majorConfig?.systemSettings.recordsPerPage ?? defaultPageSize,
  }
  if (columnSettings && columnSettings.length > 0) {
    data.isDesc = false
    data.sortColumns = [columnSettings[0].propertyName]
  }
  return data
}
